import { Component, OnInit, ViewChild, Input, Output, EventEmitter, Injector } from '@angular/core';
import { AlertComponent } from 'src/app/alert/alert.component';
import { TransactionService } from 'src/app/services/transaction.service';
import { AppConstants } from "src/app/app_setting/app-constants";

@Component({
  selector: 'app-detail-pool-order',
  templateUrl: './detail-pool-order.component.html',
  styleUrls: ['./detail-pool-order.component.css']
})
export class DetailPoolOrderComponent implements OnInit {
  @Input() id: string;
  @Output() backToList: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("alertModal") alertModal: AlertComponent;

  data: any;
  public counter417 = 0;

  constructor(
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.getDetailPoolOrder(this.id);
  }

  getDetailPoolOrder(id: string) {
    this.transactionService.getDetailPoolOrder(id,
      (resp) => {
        this.data = resp.data;
      },
      (err) => {
        this.alertModal.show("Gagal", err.message);
      }
    )
  }

  back() {
    this.backToList.emit();
  }

  resolveProductImage(imageUrl: string): string {
    if (imageUrl === null || imageUrl === "" || imageUrl === undefined) {
      return AppConstants.ProductImageDefault;
    }

    return imageUrl;
  }

  changeSource(event) {
    event.target.src = AppConstants.ProductImageDefault;
  }
}
